import React from "react";
import { Flex, FlexList } from "@procore/core-react";
import type { BryntumTaskBoard } from "@bryntum/taskboard-react-thin";
import { BoardsConfigButton } from "./config-button";
import { BoardsDateSelector } from "./date-selector";
import { BoardsFilterPanelButton } from "./boards-filter-button";
import { BoardsFilterPills } from "./boards-filter-pills";
import { BoardsHelpButton } from "./help-button";
import type { BoardsFilterTypes } from "../filter-panel";
import { BenchButton } from "../../bench/bench-button";
import "./index.css";

interface BoardsControlPanelProps {
   taskBoardRef: React.RefObject<BryntumTaskBoard>;
   isBenchPanelOpen: boolean;
   isFilterPanelOpen: boolean;
   onFilterPanelToggle: () => void;
   onBenchPanelToggle: () => void;
   boardsFilter: BoardsFilterTypes;
   onFilterUpdate: <K extends keyof BoardsFilterTypes>(key: K, value: BoardsFilterTypes[K]) => void;
}

export default function BoardsControlPanel({
   taskBoardRef,
   isBenchPanelOpen,
   isFilterPanelOpen,
   onFilterPanelToggle,
   onBenchPanelToggle,
   boardsFilter,
   onFilterUpdate,
}: BoardsControlPanelProps) {
   return (
      <Flex direction="row" gap="sm" className="boardsControlPanelWrapper">
         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <BoardsDateSelector taskBoardRef={taskBoardRef} />
            <BoardsFilterPanelButton isOpen={isFilterPanelOpen} onToggle={onFilterPanelToggle} />
            <BoardsFilterPills boardsFilter={boardsFilter} onFilterUpdate={onFilterUpdate} />
         </div>
         <FlexList space="xs">
            <BoardsHelpButton />
            <BoardsConfigButton taskBoardRef={taskBoardRef} />
            <BenchButton isOpen={isBenchPanelOpen} onToggle={onBenchPanelToggle} />
         </FlexList>
      </Flex>
   );
}
